document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.custom-video');

    videos.forEach(video => {
        const customPlayButton = video.parentElement.querySelector('.custom-play-button');

        video.removeAttribute('controls');

        customPlayButton.addEventListener('click', function () {
            video.play();
            customPlayButton.style.display = 'none';
            video.setAttribute('controls', 'controls');
        });

        video.addEventListener('pause', function () {
            customPlayButton.style.display = 'block';
            video.removeAttribute('controls');
        });

        video.addEventListener('play', function () {
            customPlayButton.style.display = 'none';
            video.setAttribute('controls', 'controls');
        });
    });
});